import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  Label,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import TwoDateCheckBoxComponent from "./TwoDateCheckBoxComponent";

export default function ProjectPerformanceHistoryOther() {
  const [dataSource, setDataSource] = useState(null);
  const [formDataSource, setFormDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const psRef = useRef(null);

  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/otr/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values = {
            ...values,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
          };

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/otr/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values = {
            ...values,
            startDate: startDateRef.current.instance.option("value"),
            endDate: endDateRef.current.instance.option("value"),
            ps: psRef.current.instance.option("value") == true ? "1" : "0",
          };

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/otr/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/prjPerfHis/otr/${userInfo.employeeNo}/${key}`
          );
        },
      })
    );
  }, []);

  const onInitNewRow = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      ps: false,
    }));
  };

  const onEditingStart = (e) => {
    if (e.data.startDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        startDate: e.data.startDate,
      }));
    }

    if (e.data.endDate) {
      setFormDataSource((prevState) => ({
        ...prevState,
        endDate: e.data.endDate,
      }));
    }

    if (e.data.ps) {
      setFormDataSource((prevState) => ({
        ...prevState,
        ps: e.data.ps,
      }));
    }
  };

  const calculateCellValue = (data) => {
    if (data.ps == "1") {
      return "진행중";
    } else {
      return ``;
    }
  };

  return (
    <DataGrid
      id="projectPerformanceHistoryOtherGrid"
      // ref={projectPerformanceHistoryClinicalTrialsGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
        // marginTop: "56px",}
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
      onEditingStart={onEditingStart}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode={"single"} />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle={"Delete the Project Performance History"}
          confirmDeleteMessage="Are you sure you want to delete this project performance history?"
        />
        <Popup
          title={"Project Performance History"}
          showTitle={true}
          height="auto"
        />
        <Form
          abelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="projectPerformanceHistoryOtr"
          height={"100%"}
        >
          <SimpleItem
            dataField={"pName"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"프로젝트명"} />
          </SimpleItem>
          <SimpleItem
            dataField={"role"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"수행업무"} />
          </SimpleItem>
          <SimpleItem
            dataField={"roleP"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
          >
            <Label text={"프로젝트 내 역할"} />
          </SimpleItem>
          <SimpleItem>
            <Label text={"수행기간"} />
            <TwoDateCheckBoxComponent
              firstDateBox={{
                placeholder: "수행시작일",
                field: "startDate",
                ref: startDateRef,
              }}
              secondDateBox={{
                placeholder: "수행종료일",
                field: "endDate",
                ref: endDateRef,
              }}
              checkBox={{
                field: "ps",
                text: "진행중",
                ref: psRef,
              }}
              formDataSource={formDataSource}
            />
          </SimpleItem>
          <SimpleItem
            dataField={"details"}
            editorType="dxTextBox"
            editorOptions={{
              showClearButton: true,
            }}
            colSpan={4}
          >
            <Label text={"상세내용"} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column dataField="pName" caption="프로젝트명" />
      <Column dataField={"role"} caption="수행업무" />
      <Column dataField={"roleP"} caption="프로젝트 내 역할" />
      <Column
        dataField={"startDate"}
        caption="수행시작일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"endDate"}
        caption="수행종료일"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
      />
      <Column
        dataField={"ps"}
        caption="진행중"
        calculateCellValue={calculateCellValue}
      />
      <Column dataField={"details"} caption="상세내용" />
    </DataGrid>
  );
}
